import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { AttachmentsComponent } from '../shared/attachments/attachments.component';
import { ExpensesComponent } from './expenses/expenses.component';
import { ExpenseListComponent } from './components/expense-list/expense-list.component';
import { ExpenseProcessedListComponent } from './components/expense-processed-list/expense-processed-list.component';
import { ExpenseAccountingListComponent } from './components/expense-accounting-list/expense-accounting-list.component';
import { ExpenseDialogComponent } from './components/expense-dialog/expense-dialog.component';
import { ExpenseReasonDialogComponent } from './components/expense-reason-dialog/expense-reason-dialog.component';

@NgModule({
  declarations: [
    ExpensesComponent,
    ExpenseListComponent,
    ExpenseProcessedListComponent,
    ExpenseAccountingListComponent,
    ExpenseDialogComponent,
    ExpenseReasonDialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    AttachmentsComponent
  ]
})
export class ExpensesModule { }
